export const ScheduleAppointStatus = {
  SuccessStatusCode: [0, 23],
  ErrorStatusCode: {
    13: 'Msg_039',
    11: 'Msg_037',
    40:'Msg_029'
  },
  GeneralMsg: 'Msg_042'
};
